import { BookingFormMode } from "PFApp/booking/components/booking_form";
import { useDetailsPanelsActions } from "PFApp/booking/components/details_panel";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { useTranslation } from "react-i18next";

import useBookingModulePermissions from "../../../../../use_booking_module_permissions";
import css from "../../../../parts/overview/detail_view/detail_view.module.scss";

type ButtonsProps = {
  id: number;
};

export const Buttons = ({ id }: ButtonsProps) => {
  const { t } = useTranslation("bookingModule");
  const { isPermittedToEdit } = useBookingModulePermissions();
  const { checkWriteAccessToAtLeastOneCategory } = useBookingCategories();
  const hasWriteAccessToAtLeastOneCategory = checkWriteAccessToAtLeastOneCategory({ demandRelated: false });
  const { openBookingFormSidePanel } = useDetailsPanelsActions();

  return (
    <div className={css.buttons}>
      <Button
        text={t("details.profile.addBooking")}
        className={css.button}
        kind="secondary"
        onClick={() => openBookingFormSidePanel({ profileId: id }, { mode: BookingFormMode.Create })}
        disabled={!hasWriteAccessToAtLeastOneCategory}
      />
      {isPermittedToEdit && (
        <ButtonLink rootClassName={css.button} kind="secondary" href={`/profiles/${id}/matching_roles`}>
          {t("details.profile.findRoles")}
        </ButtonLink>
      )}
    </div>
  );
};
